import { AxiosPromise } from "axios";
import http from "./http";

export function uploadFile(
	file: any
): AxiosPromise<any> {
	return http({
		method: 'POST',
		url: `/p/addFile`,
		data: file,
	})
}
